export const SLA_EXPERIENCE = 'viewBoardFilterBar';
export const SLA_LOCATION = 'ng-board-filter-bar';
export const EXPERIENCE_ID = 'ng-board-filter-bar';
